<template>
  <div class="gamma-decay-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>X* → X + γ | 高能光子辐射$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Nuclear Energy Levels -->
          <line x1="50" y1="80" x2="150" y2="80" stroke="#ff4757" stroke-width="2" />
          <line x1="50" y1="180" x2="150" y2="180" stroke="#2ed573" stroke-width="2" />
          
          <text x="160" y="85" fill="#ff4757" font-size="8">激发态 (E*)</text>
          <text x="160" y="185" fill="#2ed573" font-size="8">基态 (E₀)</text>

          <!-- Nucleus in Excitation -->
          <g v-if="!decayed" transform="translate(100, 80)">
             <circle r="15" fill="rgba(255, 71, 87, 0.4)" stroke="#ff4757">
                <animate attributeName="r" values="15;18;15" dur="0.2s" repeatCount="indefinite" />
             </circle>
          </g>

          <!-- Decay process -->
          <g v-if="decayed">
             <!-- Transition dot -->
             <circle :cx="100" :cy="particleY" r="5" fill="#fff" />
             <!-- Gamma Wavefront -->
             <g v-if="waveActive" transform="translate(100, 150)">
                <path d="M 0,0 Q 10,-20 20,0 T 40,0 T 60,0" fill="none" stroke="#ffd700" stroke-width="3">
                   <animate attributeName="transform" type="translate" from="0,0" to="200,0" dur="1s" repeatCount="indefinite" />
                </path>
                <text x="40" y="-20" fill="#ffd700" font-size="8">γ 射线</text>
             </g>
          </g>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>过程: {{ statusText }}</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <el-button type="warning" size="mini" @click="triggerDecay" :disabled="decayed">触发跃迁</el-button>
          <el-button size="mini" @click="reset">复位核心</el-button>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>Gamma 衰变不同于 Alpha 或 Beta 衰变，它不改变原子核的质子数或中子数。当原子核处于激发态（通常由之前的 Alpha/Beta 衰变引起）时，会通过释放一个高能光子（Gamma 射线）向低能级或基态跃迁。Gamma 射线是电磁波谱中能量最高的部分，穿透力极强，是核素识别、医疗放疗和工业探伤的重要手段。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GammaDecayViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      decayed: false,
      particleY: 80,
      waveActive: false,
      timer: null
    }
  },
  computed: {
    statusText() {
       if (!this.decayed) return "原子核处于激发态";
       if (this.particleY < 180) return "发生能级跃迁";
       return "释放高能 γ 光子";
    }
  },
  methods: {
    triggerDecay() {
       this.decayed = true;
       this.animate();
    },
    animate() {
       if (this.particleY < 180) {
          this.particleY += 5;
          this.timer = requestAnimationFrame(this.animate);
       } else {
          this.waveActive = true;
       }
    },
    reset() {
       this.decayed = false;
       this.particleY = 80;
       this.waveActive = false;
       cancelAnimationFrame(this.timer);
    }
  },
  beforeDestroy() {
    if (this.animFrame) cancelAnimationFrame(this.animFrame);
    if (this.timer) clearInterval(this.timer);
  },
}
</script>

<style scoped lang="scss">
.gamma-decay-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.02); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 215, 0, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
